<template>
  <div>
    <!-- Vue tag to add header component -->
    <header-prismic/>
    <section class="page-banner" :style="{ backgroundImage: 'linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.6)), url(' + pageBannerImage + ')' }">
      <!-- Template for page title. -->
      <div class="banner-content container">
      </div>
    </section>
    <div class="container">
      <h1>Pagina niet gevonden</h1>
      <p>Sorry deze pagina bestaat niet.</p>
      <p><router-link to="/" style="text-decoration: underline;">Naar de home pagina</router-link></p>
    </div>
  </div>
</template>

<script>
import HeaderPrismic from '../components/HeaderPrismic.vue'

export default {
  name: 'home-page',
  components: {
    HeaderPrismic,
  },
  data () {
    return {
      documentId: '',
      pageBannerImage: ''
    }
  },
  methods: {
    getContent () {
      //Query to get home content
      this.$prismic.client.getSingle('homepage')
        .then((document) => {
          if (document) {
            this.documentId = document.id;
            const banner = document.data.homepage_banner[0];
            this.pageBannerImage = banner.image.url;
          }
        })
    },
  },
  created () {
    this.getContent()
  }
}
</script>
